import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { tableNames } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { FirebaseProvider } from '../firebase/firebase';

@Injectable()
export class RepoProvider {

  constructor(
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
  ) {}

  /**
   * Recuperar propietats del repositori.
   */
  getProperties(): Observable<any> {
    return this.firebaseService.object(this.getBaseRoot() + tableNames.Properties);
  }

  /**
   * Recuperar propietats del repositori (només una vegada).
   */
  getPropertiesOnce(): Observable<any> {
    return this.firebaseService.objectOnce(this.getBaseRoot() + tableNames.Properties);
  }

  /**
   * Arrel base dins la base de dades.
   */
  private getBaseRoot(): string {
    return tableNames.Repo + '/' + this.globalVars.user.repo + '/';
  }
}



// WEBPACK FOOTER //
// ./src/providers/repo/repo.ts